export default __webpack_public_path__ + "static/media/SW.b7c8b0a8.png";